export default {
    url: '/events/edit/:id',
    template: '<events-edit courses="vm.courses" event="vm.event"></events-edit>',
    resolve: {
        event: (EventResource, $stateParams) => {
            return EventResource.get({ id: $stateParams.id, expand: 'templates.templateI18ns,courses,templates.times,createdBy' }).$promise;
        }
    },
    controller ($scope, event) {
        this.event = event;
        this.sites = $scope.$parent.vm.sites;
        this.courses = $scope.$parent.vm.courses;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/events/edit/index.js